/** @jsxImportSource */
import styled from '@emotion/styled/macro';

export const Table = styled.div`
  font-size: 13px;
  display: table;
  border-collapse: collapse;
  height: 100%;
  width: 100%;
`;

export const Thead = styled.div`
  display: table-header-group;
`;

export const Tr = styled.div`
  display: table-row;
`;

export const Th = styled.div`
  display: table-cell;
  padding: 10px;
  background-color: #f0f0f1;
  border-bottom: 1px solid #d4d9dc;
`;

export const Td = styled.div`
  display: table-cell;
  padding: 10px;
  border-bottom: 1px solid #d4d9dc;
`;

export const Tbody = styled.div`
  display: table-row-group;
  & > ${Tr} {
    &:last-child > ${Td}{
      border-bottom: none;
    };
    &:hover {
      background-color: rgba(0,0,0,.04);
    };
  }
`;

export const CenterCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

